import { render, staticRenderFns } from "./SuscriptionModal.vue?vue&type=template&id=2d6f459d&scoped=true"
import script from "./SuscriptionModal.vue?vue&type=script&lang=js"
export * from "./SuscriptionModal.vue?vue&type=script&lang=js"
import style0 from "./SuscriptionModal.vue?vue&type=style&index=0&id=2d6f459d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f459d",
  null
  
)

export default component.exports